import { apiBaseUrl } from "../../configuration";
import axios from "axios";

export const authenticate = async (username, password) => {
  try {
    const response = await axios({
      method: "post",
      //mode: "no-cors",
      url: `${apiBaseUrl}/authenticate`,
      data: {username: username, password: password}
    });

    if (response.data.response === 200) {
      //console.log("Success!")
    } else {
      //console.log("Problem");
    }
    return response;
  } catch (e) {
    console.log("Error when authenticating user");
  }
};

export const authenticateToken = async (token) => {
  try {
    const response = await axios({
      method: "post",
      mode: "no-cors",
      url: `${apiBaseUrl}/authenticateToken`,
      data: {token: token}
    });

    // if (response.data.response === 200) {
    //   //console.log("data > authenticateToken > " + token);
    // } else {
    //   console.log("data > authenticateToken > Error");
    // }
    return response;
  } catch (e) {
  }
};

export const getAllHelpContent = async majorVersion => {
  const response = await axios({
    method: "post",
    url: `${apiBaseUrl}/help/articles`,
    data: {
      majorVersion: majorVersion
    }
  });
  return response;
};

export const getHelpContent = async (type, id, majorVersion) => {
  const response = await axios({
    method: "post",
    url: `${apiBaseUrl}/help/${type}/`,
    data: {
      id: id,
      majorVersion: majorVersion
    }
  });
  return response;
};

export const getHelpSearchResults = async (searchTerms, majorVersion) => {
  const response = await axios({
    method: "post",
    url: `${apiBaseUrl}/help/search/`,
    data: {
      searchTerms: searchTerms,
      majorVersion: majorVersion
    }
  });
  return response;
};

export const getLatestCityCADVersion = async() => {
  const response = await axios({
    method: "get",
    url: `${apiBaseUrl}/version`
  });
  return response;
};

export const getSearchResults = async (searchTerms, majorVersion) => {
  const response = await axios({
    method: "post",
    url: `${apiBaseUrl}/search`,
    data: {
      searchTerms: searchTerms,
      majorVersion: majorVersion
    }
  });
  return response;
};

export const getCities = async (name) => {
  const response = await axios({
    method: "post",
    url: `${apiBaseUrl}/cities/search`,
    data: {name: name}
  });
  return response;
};

export const getUserDetails = async (token) => {
  const response = await axios({
    method: "post",
    url: `${apiBaseUrl}/clientDetails`,
    data: {token: token}
  });
  return response;
};
